import { container } from '@/auth';
import { saveAvatarSelection } from '@/gamification';
import { useSessionStore } from '@/common';

const { queriesController  , commandsController, persistanceController } = container;

function persisteChildSelection(childId) {
  persistanceController.persistValue('childSelected', childId);
  const store = useSessionStore();
  store.childSelectedId = childId;
}

async function getChildData(childId) {
  const { avatar } = await queriesController().fetchChildDataRequest(childId);
  return { avatar };
}

async function getChildrenData(parentId) {
  const requestResponse = await queriesController().fetchChildrenInfo(parentId);
  const childList = requestResponse.map((element) => {
    return element.child;
  });
  return childList;
}

async function loadUserData() {
  try {
    await queriesController().fetchUserData();
    const store = useSessionStore();
    const userId = store.userId;
    const requestResponse = store.userIsAParent
      ? await queriesController().fetchParentDataRequest(userId)
      : await queriesController().fetchChildDataRequest(userId);
    store.themeSelection = requestResponse.themeSelection;
  } catch (error) {
    throw new Error('[Service]: Oops!, Failed to get user information ');
  }
}

async function login({ username, password }) {
  await commandsController().loginRequest({ username, password });
}

async function logout() {
  await persistanceController.removeAll();
}

async function recoveryPassword({ email }) {
  await commandsController().recoverPasswordRequest({ email });
}

async function registerChild({
  name,
  last_name,
  modulesUnlocked,
  email,
  birthdate,
  password,
  re_password,
  avatarId,
  profile_gender,
}) {
  try {
    const registerChild = await commandsController().registerChild({
      name,
      last_name,
      modulesUnlocked,
      email,
      birthdate,
      password,
      re_password,
      profile_gender,
    });
    const { id } = registerChild;
    persisteChildSelection(id);
    if (avatarId > 0) {
      await saveAvatarSelection({ childId: id, avatarId: avatarId });
    }
    return registerChild;
  } catch (error) {
    throw new Error('[Service]: Oops!, Failed to register child.');
  }
}

async function setRefreshToken({ refreshToken }) {
  return await commandsController().setRefreshToken({ refreshToken });
}

export {
  persisteChildSelection,
  getChildData,
  getChildrenData,
  loadUserData,
  login,
  logout,
  recoveryPassword,
  registerChild,
  setRefreshToken,
};
